import { render } from "./RequisitosViaje.vue?vue&type=template&id=57c13813"
import script from "./RequisitosViaje.vue?vue&type=script&lang=js"
export * from "./RequisitosViaje.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__